import {isPossiblePhoneNumber} from "libphonenumber-js";
import moment from "moment-timezone";

export const NoSpaces = (value: string) => value.toString().indexOf(" ") === -1;

export const NoLeadingSpaces = (value: string | null) => {
    if (value === null || value.toString().length === 0) return true;
    return !(value.toString()[0] === " ");
};

export const NoLeadingZeros = (value: string | null) => {
    if (value === null || value.toString().length === 0) return true;
    return !(value.toString()[0] === "0");
};

export const NoTrailingSpaces = (value: string | null) => {
    if (value === null || value.toString().length === 0) return true;
    return !(value[value.toString().length - 1] === " ");
};

export const NoSpecialCharacters = (value: string) => !!value.toString().match("^[a-zA-Z0-9@\\ \\-\\.\\_\\+]*$");

export const Minimum = (value: string, boundary: number) => value.toString().length >= boundary;

export const Maximum = (value: string, boundary: number) => value.toString().length <= boundary;

export const MaximumValue = (value: number, maximum: number) => value <= maximum;

export const MinimumValue = (value: number, minimum: number)  => value >= minimum;

export const NotAllSpaces = (value: string) => value.trim().length !== 0;

export const Required = (value: string | undefined) => value !== undefined && value !== null && value.toString().length > 0;

export const OptionalPattern = (value: string, pattern: string) => {
    if (value !== null && value.toString().length > 0) {
        return !!value.toString().match(pattern);
    }
    return true;
};

export const Float = (value: number) => !isNaN(Number(value));

export const NumbersOnlyPattern = (value: string, pattern: string) => {
    if (value !== null && value.toString().length > 0) {
        return !!value.toString().match(pattern);
    }
    return true;
};

export const RequiredInteger = (value: string) => !value.toString().includes(".");

export const RequiredPattern = (value: string, pattern: string) => !!value.toString().match(pattern);

export const MatchValues = (value: string, otherFieldValue: string) => value === otherFieldValue;

export const AllOrNone = (value: string, otherFieldValues: string[]) => {
    let othersEmpty = true;
    otherFieldValues.forEach((x: string) => othersEmpty && (x?.length ?? 0) === 0);
    if ((value?.length ?? 0) === 0 && !othersEmpty) return false;
    return true;
};

export const EitherValues = (value: string, otherFieldValue: string) => {
    return (
        (value !== null && value.length > 0) ||
        (otherFieldValue !== null && otherFieldValue.length > 0)
    );
};

export const EitherValuesNotNULL = (value: string, otherFieldValue: string) => {
    if (((!value || value === "NULL") && (!otherFieldValue || otherFieldValue === "NULL"))) return false;
    return true;
};

export const OneCheckboxMustBeTrue = (fields: any, values: any) => {
    let found = false;
    for (let i = 0; i < fields.length; i++) {
        let field = fields[i];

        if (values[field] !== "" && values[field] !== null && values[field] !== false) {
            found = true;
        }
    }

    return found;
};

export const OneFieldMustBeProvided = (fields: any, values: any, controls: any) => {
    let found = false;
    for (let i = 0; i < fields.length; i++) {
        let field = fields[i];

        if (values[field] !== "" && values[field] !== null && values[field] !== false && controls[field].type === "Checkbox") {
            found = true;
        } else if (values[field] !== "" && values[field] !== null && controls[field].type !== "Checkbox") {
            found = true;
        }
    }
    return found;
};

export const CannotMatchValues = (value: string, otherFieldValue: string) => {
    if (value.length === 0 && otherFieldValue.length === 0) return true;
    return value !== otherFieldValue;
};

export const CannotMatchValuesCaseInsensitive = (value: string, otherFieldValue: string) => {
    if (value.length === 0 && otherFieldValue.length === 0) return true;
    return value.toLowerCase() !== otherFieldValue.toLowerCase();
};

export const PhoneRegex = /^\(?([2-9][0-9]{2})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
export const IsPhone = (value: string) => isPossiblePhoneNumber(value, "US");

export const EmailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const IsEmail = (value: string) => EmailRegex.test(value);

export const IsSameOrBeforeDay = (value: string, otherFieldValue: string) => {
    if (!value || moment(value).isSameOrBefore(otherFieldValue, "day")) return true;
    return false;
};

export const IsSameOrAfterDay = (value: string, otherFieldValue: string) => {
    if (!value || moment(value).isSameOrAfter(otherFieldValue, "day")) return true;
    return false;
};
